import Icon from '@ant-design/icons'
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

// 取消归档
/* eslint-disable */
const Svg = () => (
  // eslint-disable-next-line
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5124 14.1087H5.00228V16.5686H2.5124V14.1087ZM6.8022 12.0326H9.29208V16.5686H6.8022V12.0326ZM10.672 9.64929H13.1619V16.5986H10.672V9.64929ZM14.9768 7.19124H17.4667V16.5986H14.9768V7.19124ZM2.96286 12.0326L2.1084 11.1901L9.14034 4.05862L9.80336 7.9071L15.8562 2.34983L16.6678 3.2338L8.9943 10.279L8.35442 6.56478L2.96286 12.0326ZM13.7148 2.79182L17.4776 1.54688L16.262 5.35264L15.5962 3.10686L13.7148 2.79182Z" fill="url(#paint0_linear_3444_14411)" />
    <defs>
      <linearGradient id="paint0_linear_3444_14411" x1="2.1084" y1="9.07274" x2="17.4776" y2="9.07274" gradientUnits="userSpaceOnUse">
        <stop stopColor="#0CB6FF" />
        <stop offset="1" stopColor="#288EFF" />
      </linearGradient>
    </defs>
  </svg>


)

const IconComponent = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={Svg} {...props} />
)

export default IconComponent
